import { render, staticRenderFns } from "./ModalSinaleiraLucratividade.vue?vue&type=template&id=2d62d4e0&scoped=true"
import script from "./ModalSinaleiraLucratividade.vue?vue&type=script&lang=js"
export * from "./ModalSinaleiraLucratividade.vue?vue&type=script&lang=js"
import style0 from "./ModalSinaleiraLucratividade.vue?vue&type=style&index=0&id=2d62d4e0&prod&scoped=true&lang=css"
import style1 from "./ModalSinaleiraLucratividade.vue?vue&type=style&index=1&id=2d62d4e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62d4e0",
  null
  
)

export default component.exports